import React from "react";

const HoverTooltip = ({ content, x, y }) => {
  return (
    <div 
      className="absolute bg-white border border-gray-200 shadow-lg rounded-md p-3 max-w-xs z-50"
      style={{ 
        top: y, 
        left: x, 
        transform: 'translateX(-250px)' 
      }}
    >
      {content}
    </div>
  );
};

export default HoverTooltip;